var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 24,
    viewBox: "0 0 31 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4133 5.13066C28.2621 4.5167 27.9542 3.95417 27.5207 3.49988C27.0872 3.04559 26.5434 2.71563 25.9443 2.54334C23.7554 2 14.9995 2 14.9995 2C14.9995 2 6.24354 2 4.05457 2.59508C3.45546 2.76738 2.91169 3.09734 2.47818 3.55163C2.04467 4.00591 1.73678 4.56845 1.5856 5.18241C1.18499 7.44056 0.989024 9.73132 1.00018 12.0259C0.985898 14.3377 1.18187 16.6459 1.5856 18.9211C1.75227 19.516 2.06706 20.0571 2.49956 20.4922C2.93205 20.9273 3.46764 21.2417 4.05457 21.4049C6.24354 22 14.9995 22 14.9995 22C14.9995 22 23.7554 22 25.9443 21.4049C26.5434 21.2326 27.0872 20.9027 27.5207 20.4484C27.9542 19.9941 28.2621 19.4316 28.4133 18.8176C28.8108 16.5764 29.0068 14.3031 28.9987 12.0259C29.013 9.71404 28.817 7.40582 28.4133 5.13066V5.13066Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16L20 12L12 8V16Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.7af4783b4c5afec805f0c2f9abe4eac6.svg";
export { ForwardRef as ReactComponent };